import { createAction } from 'store/utils';

export const resetGtagEvents = createAction('RESET_GTAG_EVENTS');
